const headerMenu = {
    data() {
        return {
            selectedCard: null,
            flipped: false,
            header: null,
            headerCards: null
        }
    },
    mounted(){

        this.headerCards = window.headerCards;

               
        this.$nextTick(() => {
         
            this.header = jQuery(this.$el)
            
            this.header.parents('.header__layer').headerDesktop()
            this.header.parents('.header__layer').headerScroll()
        })
    },
    methods:{
        selectCard(id){
            if(id === false){
                this.selectedCard = null
                return;
            }

            if(this.headerCards && this.headerCards[id]){

                if(this.selectedCard && this.selectedCard.id && this.selectedCard.id !== this.headerCards[id].id)
                    this.flipped = !this.flipped;

                this.selectedCard = this.headerCards[id];
            }
        },
        isSelectedCard(card){
           
            if(this.selectedCard && card){

                return this.selectedCard.id === card.id;
            }
           
            return false;
        },
        activeClass(card){
            return this.isSelectedCard(card) ? 'active' : 'inactive';           
        }
    }
}
const headerMenuApp = Vue.createApp(headerMenu)
headerMenuApp
    .component("header-card", headerCard)

const selHeader = document.querySelector('#header-app')
if(selHeader)
    headerMenuApp.mount(selHeader)